<template>
  <vx-card class="overflow-hidden">
    <div slot="no-body">
      <div class="p-6 text-center">
        <card-header :title="title" :slug="slug"/>
        <div class="vx-row">
          <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
            <div class="box-border">
              <div class="in-out-title text-success">IN</div>
              <div class="in-out-value">{{ inData }}</div>
            </div>
          </div>
          <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
            <div class="box-border">
              <div class="in-out-title text-danger">OUT</div>
              <div class="in-out-value">{{ outData }}</div>
            </div>
          </div>
          <div class="vx-col w-full mt-10">
            <div class="box-border">
              <div class="in-out-title-total">TOTAL</div>
              <div class="in-out-value-total">{{ totalData }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import CardHeader from "./card-header.vue";
export default {
  props: ["title", "slug", "inData", "outData", "totalData"],
  components: { CardHeader },
};
</script>

<style lang="scss" scoped>
.in-out-title {
  font-weight: 700;
  font-size: 14pt;
}
.in-out-value {
  font-size: 28pt;
}
.in-out-title-total {
  font-weight: 700;
  font-size: 18pt;
}
.in-out-value-total {
  font-weight: 700;
  font-size: 32pt;
}
.box-border {
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 20px 0;
}
</style>
